export default "__VITE_ASSET__DSQ9d$x6__";